import { gql } from '@apollo/client';

export const GET_USERS_BY_HILDA = gql`
  query UsersByHildaId($hildaId: BigInt!, $whereHilda: WhereHilda!) {
    usersByHildaId(hildaId: $hildaId) {
      id
      firstName
      lastName
      email
      roleId
      advisorFirmId
      dateOfBirth
      phoneNumber
    }
    hilda(whereHilda: $whereHilda) {
      id
      name
      email
      createdAt
      hildaTypeId
      trustDocumentURL
      taxId
      secondaryTaxId
      accountTitle
      hildaTypeId
      advisor {
        firstName
        lastName
        email
      }
      institution {
        institutionType {
          code
          description
        }
      }
      address {
        streetAddress1
        city
        country
        state
        stateCode
        zipCode
      }
    }
  }
`;